export default __webpack_public_path__ + "static/media/logo.1309d2f4.svg";